import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControlLabel,
  LinearProgress,
  Radio,
  RadioGroup,
  makeStyles
} from '@material-ui/core'
import clsx from 'clsx'
import moment from 'moment'
import 'moment/locale/pt-br'
import React, { useContext, useEffect, useLayoutEffect, useState } from 'react'

import { createClipping, getProductsList } from '../../services/ClippingApi'
import { getLoggedUser, isAuthenticated } from '../../services/auth'

import Context from '../../context'
import history from '../../services/history'

import ClippingPartnersModal from '../../components/ClippingPartnersModal'
import { getPartnersList } from '../../services/ClubeApi'
import ImageUploadToS3 from '../../services/ImageUpload'

function ClippingForm(props) {
  const { setUser, setAboutCurrentPage, setShowLoadingModal } = useContext(Context)
  const { clippingToEdit = {} } = props.location.state || {}

  const [clippingData, setClippingData] = useState({
    id: clippingToEdit.id,
    title: clippingToEdit.title || '',
    description: clippingToEdit.description || '',
    clippingProductsId: clippingToEdit.clippingProductsId,
    partnerId: clippingToEdit.partnerId,
    date: clippingToEdit.date || '',
    cover: clippingToEdit.cover || ''
  })
  const [files, setFiles] = useState(
    clippingToEdit.ClippingContents?.filter(item => item.typeClipping === 1) || []
  )
  const [linkUrl, setLinkUrl] = useState(
    clippingToEdit.ClippingContents?.find(item => item.typeClipping === 2)?.value || ''
  )
  const [typeContents, setTypeContents] = useState(
    clippingToEdit.ClippingContents?.some(item => item.typeClipping === 1) ? 'files' : 'link'
  )
  const [productsList, setProductsList] = useState([])
  const [fullPartnerList, setFullPartnerList] = useState([])
  const [selectedPartnerList, setSelectedPartnerList] = useState([])
  const [loading, setLoading] = useState(true)
  const [errors, setErrors] = useState(null)
  const [shouldExclude, setShouldExclude] = useState(false)
  const classes = useStyles()

  const setClippingDataIfPossible = param =>
    !loading && setClippingData(clippingData => ({ ...clippingData, ...param }))
  const setFilesIfPossible = (param, spread = true) =>
    !loading && setFiles(files => [...(spread ? files : []), ...param])
  const setLinkUrlIfPossible = param => !loading && setLinkUrl(param)
  const setTypeContentsIfPossible = param => !loading && setTypeContents(param)

  // const setSelectedPartnerListIfPossible = param =>
  //   !loading && setSelectedPartnerList(param);

  // workaround for selecting just one partner
  useLayoutEffect(() => {
    const partnerObj = [...selectedPartnerList].pop()
    if (!partnerObj) return

    setClippingDataIfPossible({
      partnerId: partnerObj.id
    })
    // if (selectedPartnerList.length > 1)
    // setSelectedPartnerListIfPossible([partnerObj]);
  }, [selectedPartnerList])

  useEffect(() => {
    if (!isAuthenticated) return history.replace('/')

    setUser(getLoggedUser)
    setAboutCurrentPage({
      title: props.location.state ? 'Editar clipping' : 'Adicionar clipping'
    })
    getProductsList().then(r => setProductsList(r || []))
    getPartnersList().then(r => {
      if (r) {
        setLoading(false)
        setFullPartnerList([...r])
      }
    })
  }, [])

  const hideErrorsModal = () => setErrors(null)
  const showExcludeModal = () => setShouldExclude(true)
  const hideExcludeModal = () => setShouldExclude(false)

  const checkErrors = () => {
    const errors = []
    // title
    if (!clippingData.title.trim()) errors.push('Sem título')
    // date
    if (!clippingData.date) errors.push('Sem data')
    else if (!moment(clippingData.date, 'YYYY-MM-DD').isValid()) errors.push('Data inválida')
    // cover
    if (!clippingData.cover) errors.push('Sem imagem de capa')
    else if (
      clippingData.cover instanceof File &&
      !['image/jpeg', 'image/png', 'image/gif'].includes(clippingData.cover.type)
    )
      errors.push('Tipo de imagem de capa inválido')
    // content === link
    if (
      typeContents === 'link' &&
      !/^https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/.test(
        linkUrl
      )
    )
      errors.push('URL do conteúdo inválida')
    // content === files
    if (typeContents === 'files' && files.length === 0)
      errors.push('Nenhum arquivo de conteúdo selecionado')
    // product
    if (!productsList.find(({ id }) => id === clippingData.clippingProductsId))
      errors.push('Nenhum produto selecionado')
    // partner
    if (
      !clippingData.partnerId ||
      !fullPartnerList.find(item => item.id === clippingData.partnerId)
    )
      errors.push('Nenhum parceiro selecionado')

    return !!errors.length && errors
  }

  const save = async () => {
    const errors = checkErrors()
    if (errors) {
      setErrors(errors)
      return
    }

    setLoading(true)
    setShowLoadingModal(true)

    const cover =
      clippingData.cover instanceof File
        ? process.env.REACT_APP_IMAGES_URL +
          (await ImageUploadToS3(clippingData.cover, 'clipping/'))
        : clippingData.cover

    const clippingContent = {
      link: [{ typeClipping: 2, value: linkUrl }],
      files: await Promise.all(
        files.map(async file => {
          if (file.value instanceof File) {
            const path = await ImageUploadToS3(file.value, 'clipping/')
            return { ...file, value: process.env.REACT_APP_IMAGES_URL + path }
          }

          return file
        })
      )
    }[typeContents]

    selectedPartnerList.forEach(async partner => {
      await createClipping({
        ...clippingData,
        partnerId: partner.id,
        cover,
        clippingContent
      })
    })

    setLoading(false)
    setShowLoadingModal(false)

    history.push('/clipping')
  }

  const exclude = async () => {
    setLoading(true)
    await createClipping({
      ...clippingData,
      situation: 2
    })
    setLoading(false)
    history.push('/clipping')
  }

  return (
    <Context.Provider
      value={{
        selectedPartnerList,
        setSelectedPartnerList,
        // setSelectedPartnerListIfPossible,
        fullPartnerList
      }}
    >
      <div className={classes.outerContainer}>
        {loading ? <LinearProgress /> : null}
        <div className={classes.content}>
          <div className={classes.main}>
            <div className={classes.twoColumns}>
              <div className={classes.inputGroup}>
                <span>Título</span>
                <input
                  value={clippingData.title}
                  onChange={e =>
                    setClippingDataIfPossible({
                      title: e.target.value
                    })
                  }
                />
              </div>
              <div className={classes.inputGroup}>
                <span>Data</span>
                <input
                  value={clippingData.date.split('-').reverse().join('/')}
                  onChange={e =>
                    setClippingDataIfPossible({
                      date: e.target.value
                        .replace(/[\D]/g, '')
                        .substr(0, 8)
                        .replace(/^(\d{2})/, '$1/')
                        .replace(/(\/\d{2})/, '$1/')
                        .split('/')
                        .reverse()
                        .join('-')
                    })
                  }
                />
              </div>
              <div className={clsx(classes.inputGroup, classes.fullRowTwoColumns)}>
                <span>Descrição</span>
                <textarea
                  value={clippingData.description}
                  onChange={e =>
                    setClippingDataIfPossible({
                      description: e.target.value
                    })
                  }
                />
              </div>
            </div>
            <div className={classes.divider} />
            <h4 className={classes.subtitle}>Conteúdos</h4>
            <div className={classes.group}>
              <RadioGroup
                className={clsx(typeContents !== 'files' && classes.fullRowTwoColumns)}
                row
                value={typeContents}
                onChange={e => setTypeContentsIfPossible(e.target.value)}
              >
                <FormControlLabel
                  value="link"
                  control={
                    <Radio classes={{ root: classes.radio, checked: classes.radio }} size="small" />
                  }
                  label={<span className={classes.radioLabels}>Link</span>}
                />
                <FormControlLabel
                  value="files"
                  control={
                    <Radio classes={{ root: classes.radio, checked: classes.radio }} size="small" />
                  }
                  label={<span className={classes.radioLabels}>Arquivos</span>}
                />
              </RadioGroup>
              {typeContents === 'link' && (
                <div className={classes.inputGroup}>
                  <span>URL</span>
                  <input value={linkUrl} onChange={e => setLinkUrlIfPossible(e.target.value)} />
                </div>
              )}
              {typeContents === 'files' && (
                <>
                  <label>
                    <input
                      className={classes.hiddenInput}
                      type="file"
                      multiple
                      accept="*/*"
                      onChange={e => {
                        setFilesIfPossible(
                          [...e.target.files].map(file => ({
                            value: file,
                            typeClipping: 1
                          }))
                        )
                        e.target.value = ''
                      }}
                    />
                    <span className={clsx(classes.plainButton, classes.plainButtonShade)}>
                      Adicionar arquivos
                    </span>
                  </label>
                  {files.map((file, index) => {
                    return (
                      <div key={index} className={classes.outlinedItem}>
                        <div>
                          {typeof file.value === 'string' ? (
                            file.value
                          ) : (
                            <>
                              {file.value.name} ({file.value.type})
                            </>
                          )}
                        </div>
                        <label>
                          <button
                            type="button"
                            className={classes.hiddenInput}
                            onClick={() =>
                              setFilesIfPossible(
                                files.filter((_, i) => i !== index),
                                false
                              )
                            }
                          />
                          <span className={clsx(classes.plainButton, classes.plainButtonRed)}>
                            Excluir
                          </span>
                        </label>
                      </div>
                    )
                  })}
                </>
              )}
            </div>
          </div>
          <div className={classes.aside}>
            <div className={clsx(classes.box, classes.fullRowTwoColumns)}>
              <h4>Imagem de capa</h4>
              <div>
                <label>
                  {clippingData.cover ? (
                    <img
                      className={classes.img}
                      src={(image => (image instanceof File ? URL.createObjectURL(image) : image))(
                        clippingData.cover
                      )}
                    />
                  ) : null}
                  <span className={classes.plainButton}>Selecionar arquivo</span>
                  <input
                    className={classes.hiddenInput}
                    type="file"
                    accept="image/png,image/jpeg,image/gif"
                    onChange={e =>
                      setClippingDataIfPossible({
                        cover: e.target.files[0]
                      })
                    }
                  />
                </label>
                <span className={classes.legend}>Arquivo .png, .jpg ou .gif</span>
              </div>
            </div>
            <div className={clsx(classes.box, classes.fullRowTwoColumns)}>
              <h4>Parceiro</h4>
              <div>
                <label>
                  <button
                    type="button"
                    className={classes.hiddenInput}
                    data-toggle="modal"
                    data-target="#clippingPartnersModal"
                  />
                  <span className={classes.plainButton}>Escolher parceiro</span>
                </label>
                {selectedPartnerList.length === 0 && loading && (
                  <span className={classes.legend}>Carregando parceiros...</span>
                )}
                {selectedPartnerList.length > 0 && (
                  <ul className={classes.ul}>
                    {selectedPartnerList.map(partner => (
                      <li key={partner.id}>{partner.fantasyName}</li>
                    ))}
                  </ul>
                )}
              </div>
            </div>
            <div className={clsx(classes.box, classes.fullRowTwoColumns)}>
              <h4>Produto</h4>
              <div>
                <RadioGroup
                  value={clippingData.clippingProductsId || null}
                  onChange={e =>
                    setClippingDataIfPossible({
                      clippingProductsId: Number(e.target.value)
                    })
                  }
                >
                  {productsList.map(item => (
                    <FormControlLabel
                      key={item.id}
                      value={item.id}
                      control={
                        <Radio
                          classes={{
                            root: classes.radio,
                            checked: classes.radio
                          }}
                          size="small"
                        />
                      }
                      label={<span className={classes.radioLabels}>{item.name}</span>}
                    />
                  ))}
                </RadioGroup>
              </div>
            </div>
            {props.location.state && (
              <button
                className={clsx(classes.plainButton, classes.plainButtonRed)}
                type="button"
                onClick={showExcludeModal}
              >
                Excluir
              </button>
            )}
            <button
              className={clsx(
                classes.shadowButton,
                !props.location.state && classes.fullRowTwoColumns
              )}
              type="button"
              onClick={save}
            >
              Concluir
            </button>
          </div>
        </div>
      </div>

      <ClippingPartnersModal />

      <Dialog
        open={!!errors}
        onClose={hideErrorsModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Erros encontrados</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Encontramos os seguintes erros:
            <ul>
              {errors?.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>
            Corrija-os antes de prosseguir.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideErrorsModal}>
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={shouldExclude}
        onClose={hideExcludeModal}
        transitionDuration={{ enter: 250, exit: 0 }}
      >
        <DialogTitle>Excluir</DialogTitle>
        <DialogContent>
          <DialogContentText>Deseja excluir o clipping?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button color="primary" onClick={hideExcludeModal}>
            Não
          </Button>
          <Button color="primary" onClick={exclude}>
            Sim
          </Button>
        </DialogActions>
      </Dialog>
    </Context.Provider>
  )
}

const useStyles = makeStyles({
  outerContainer: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    '& label': {
      margin: '0 !important'
    }
  },
  content: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    padding: '45px'
  },
  main: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    marginRight: 30
  },
  twoColumns: {
    display: 'grid',
    gridTemplateColumns: '4fr 1fr',
    gap: '30px 20px'
  },
  group: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, 1fr)',
    marginTop: '30px',
    padding: '30px',
    gap: '20px',
    backgroundColor: '#ece5fe',
    borderRadius: '4px'
  },
  inputGroup: {
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    '& span': {
      fontSize: '16px',
      fontWeight: 700,
      color: '#30287b'
    },
    '& input, & textarea': {
      marginTop: '10px',
      padding: '11px 13px',
      fontSize: '14px',
      color: '#30287b',
      background: '#fff',
      border: '2px solid #30287b'
    },
    '& input': {
      height: 44
    },
    '& textarea': {
      minHeight: 132,
      resize: 'none'
    }
  },
  fullRowTwoColumns: {
    gridColumn: '1 / 3'
  },
  divider: {
    marginTop: '45px',
    borderBottom: '2px solid #b294ff'
  },
  subtitle: {
    marginTop: '45px',
    fontFamily: 'Matrice',
    fontSize: '18px',
    color: '#30287b'
  },
  aside: {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, auto)',
    width: 340,
    gap: '15px'
  },
  box: {
    border: '2px solid #30287b',
    '& h4': {
      marginBottom: 0,
      fontSize: '14px',
      fontWeight: '700',
      color: '#ffffff',
      lineHeight: '44px',
      textAlign: 'center',
      textTransform: 'uppercase',
      background: '#30287b',
      borderBottom: '2px solid #30287b'
    },
    '& > div': {
      display: 'grid',
      gridTemplateColumns: 'auto',
      gap: '15px',
      padding: '30px'
    }
  },
  plainButton: {
    display: 'block',
    width: '100%',
    margin: '0',
    padding: '0 20px',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#ece5fe',
    border: 'none',
    borderRadius: '2px',
    cursor: 'pointer'
  },
  plainButtonShade: {
    color: '#fff',
    background: '#262061'
  },
  plainButtonRed: {
    color: '#fff',
    background: '#d73f32'
  },
  shadowButton: {
    width: '100%',
    fontSize: '12px',
    fontWeight: '700',
    color: '#30287b',
    lineHeight: '44px',
    textAlign: 'center',
    textTransform: 'uppercase',
    background: '#fbbb33',
    border: 'none',
    borderRadius: '2px',
    boxShadow: '4px 4px #4200f5',
    cursor: 'pointer'
  },
  img: {
    width: '100%',
    height: 'auto'
  },
  hiddenInput: {
    visibility: 'hidden',
    opacity: 0,
    position: 'absolute',
    width: 0,
    height: 0,
    margin: 0,
    padding: 0
  },
  legend: {
    fontSize: '12px',
    fontStyle: 'italic',
    color: '#30287b',
    textAlign: 'center'
  },
  radio: {
    color: '#30287b !important'
  },
  radioLabels: {
    fontSize: '14px',
    color: '#30287b'
  },
  ul: {
    listStyle: 'none',
    margin: '15px 0',
    padding: '0',
    '& li': {
      margin: '6px 0 0',
      fontSize: '14px',
      fontStyle: 'italic',
      color: '#30287b'
    }
  },
  outlinedItem: {
    alignSelf: 'start',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: '100%',
    padding: '15px',
    border: '2px solid #30287b',
    '& div': {
      flexGrow: 1,
      marginRight: '10px'
    }
  }
})

export default ClippingForm
